/**
 * API de asignaciones de pacientes — tenant-scoped.
 */
import { apiFetch } from "./client";

export type EstadoAsignacion = "ACTIVA" | "COMPLETADA" | "ARCHIVADA";

export interface Asignacion {
  id: number;
  paciente_id: number;
  /** Consulta de la que salió la derivación. */
  cita_origen_id?: number | null;
  paciente_nombre: string;
  especialidad_id: number;
  especialidad_nombre: string;
  profesional_id: number | null;
  profesional_nombre: string | null;
  sede_id: number | null;
  sede_nombre: string | null;
  motivo: string | null;
  estado: EstadoAsignacion;
  asignado_en: string;
  asignado_por_user_id: number | null;
  archivado_en: string | null;
}

export interface AsignacionCreate {
  paciente_id: number;
  /** Consulta de la que sale la derivación. */
  cita_origen_id?: number | null;
  especialidad_id: number;
  profesional_id?: number | null;
  sede_id?: number | null;
  motivo?: string | null;
}

export interface AsignacionUpdate {
  profesional_id?: number | null;
  sede_id?: number | null;
  motivo?: string | null;
  estado?: EstadoAsignacion | null;
}

export async function listAsignacionesDePaciente(
  pacienteId: number,
): Promise<Asignacion[]> {
  return apiFetch<Asignacion[]>(`/v1/pacientes/${pacienteId}/asignaciones`);
}

export async function createAsignacion(
  data: AsignacionCreate,
): Promise<Asignacion> {
  return apiFetch<Asignacion>("/v1/asignaciones", {
    method: "POST",
    body: data,
  });
}

export async function updateAsignacion(
  id: number,
  data: AsignacionUpdate,
): Promise<Asignacion> {
  return apiFetch<Asignacion>(`/v1/asignaciones/${id}`, {
    method: "PATCH",
    body: data,
  });
}

export async function archivarAsignacion(id: number): Promise<Asignacion> {
  return updateAsignacion(id, { estado: "ARCHIVADA" });
}
